export default "__VITE_ASSET__B7B3ZhXY__"